import type { ProviderTypesApi, ProviderConnectionsApi } from '@bmai/connections-api-client';

/**
 * App-wired `@bmai/connections-api-client` instance. Each consuming app
 * constructs its own (different BFF base paths, different auth surfaces)
 * and registers it under {@link ConnectionsClientToken} at boot.
 */
export interface ConnectionsClient {
    providerTypesApi: ProviderTypesApi;
    providerConnectionsApi: ProviderConnectionsApi;
}

export const ConnectionsClientToken = Symbol.for('@bmai/web-shared/ConnectionsClient');

/**
 * App-provided fetch wrapper that attaches whatever auth the app needs
 * (cookies + CSRF for bmai-web; BFF-issued bearer for bmai-assessment).
 * The package uses this for provider-callback routes that aren't part of
 * the auto-generated OpenAPI client surface.
 */
export type AuthFetch = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

export const AuthFetchToken = Symbol.for('@bmai/web-shared/AuthFetch');

/**
 * Base path the consuming app's BFF mounts the connections-api under,
 * with no trailing slash. Used by the package to build URLs for
 * provider-callback and admin-consent routes that aren't covered by the
 * auto-generated OpenAPI client.
 *
 * Examples:
 *   bmai-web:        '/_connections'
 *   bmai-assessment: '/api/connections' (or whatever the BFF proxy mounts)
 */
export const ConnectionsApiBasePathToken = Symbol.for('@bmai/web-shared/ConnectionsApiBasePath');

/**
 * Path prefix the consuming SPA is mounted under in the browser, with no
 * trailing slash and no leading host. The package uses it to build absolute
 * OAuth redirect URIs that resolve to the SPA's `oauth/callback` route.
 *
 * Examples:
 *   bmai-web (root-mounted):           '' (empty string)
 *   bmai-assessment (cloudsaver-hosted): '/_assessment'
 *   bmai-assessment (library mode):     '' (empty string)
 *
 * Apps that don't register this token get an empty string by default —
 * see {@link IntegrationsService}.
 */
export const AppBasePathToken = Symbol.for('@bmai/web-shared/AppBasePath');
